export const GET_NURSERY_SETTINGS = 'NURSERY_CONTEXT/GET_NURSERY_SETTINGS'
export const GET_NURSERY_SETTINGS_SUCCESS = 'NURSERY_CONTEXT/GET_NURSERY_SETTINGS_SUCCESS'
export const GET_NURSERY_SETTINGS_FAILED = 'NURSERY_CONTEXT/GET_NURSERY_SETTINGS_FAILED'

export const REMOVE_STRIPE_INTEGRATION = 'NURSERY_CONTEXT/REMOVE_STRIPE_INTEGRATION'
